{
  "instances": {
    "jolokia": {
      "label": "JMX",
      "close": "Fechar",
      "domains": "Domínios",
      "execute": "Executar",
      "executing": "Executando...",
      "execution_failed": "Falha na execução.",
      "execution_successful": "Execução bem sucedida.",
      "mbeans": "MBeans"
    }
  }
}
